import { ReportSequenceSubscriptionSubscription } from '../generated/hooks';
import { AggregatedData, composeTeamsMapForAggregatedData } from './reports/aggregateData';

export const aggregateDataForReportSequenceDetail = (
  teamsToProcess: NonNullable<NonNullable<ReportSequenceSubscriptionSubscription['getProcessReport']>['teams']>,
): AggregatedData => {
  const teams = composeTeamsMapForAggregatedData(teamsToProcess);
  return { teams, respondents: {} };
};
